<template>
  <div id="app">
    <div class="ui centered padded grid">
      <div class="six wide computer eight wide tablet sixteen wide mobile column">

        <language-toggle />
        <transition name="fade" mode="out-in">
          <router-view/>
        </transition>

        <transition name="fade">
          <div v-if="$route.name !== 'Login' && $route.name !== 'NotFound'" class="ui tertiary bottom fixed tiny inverted menu">
            <p class="item">{{ localisation.generic.doNotRefresh }}</p>
          </div>
        </transition>

      </div>
    </div>
  </div>
</template>

<script>

import LanguageToggle from './components/LanguageToggle.vue'

export default {
  name: 'App',
  components: {
    LanguageToggle
  },
  created () {
    if (this.$route.params.studyName) {
      this.initializeChosenStudy(this.$route.params.studyName).then(() => {
      }).catch((error) => { // navigation guard should be preventing this in the first place
        console.log(error.message)
        this.$router.push({ name: 'NotFound' })
      })
    }
  }
}

</script>

<style>
#app {
  max-width: 1100px;
  margin: auto;
}

body {
  background-color: #263d4b !important;
  color: white !important;
  -webkit-touch-callout:none;
  -webkit-tap-highlight-color:rgba(0,0,0,0) !important;
  -webkit-user-select:none;
}

.ui.inverted.segment, .ui.inverted.attached.segment {
  background-color: #1F2833 !important;
  border-radius: 0.5em;
  border: 1px solid #a9a9a9;
}

.ui.inverted.top.attached.segment {
  border: 1px solid #a9a9a9;
  border-radius: 0.5em 0.5em 0 0;
}

.ui.inverted.bottom.attached.segment {
  border: 1px solid #a9a9a9;
  border-radius: 0 0 0.5em 0.5em;
}

.ui.inverted.message {
  background-color:  #1F2833;
  border-radius:0.5em;
  border: 1px solid #a9a9a9;
}

.primary-color {
  color: #26deca !important;
}

.primary {
  background-color: #26deca !important;
  color: white !important;
}

.secondary {
  background-color: #3e838a !important;
  color: white !important;
}

.tertiary {
  background-color: #6496BB !important;
  color: white !important;
}

/* Form Input */
.ui.form input[type=email], .ui.form input[type=text], .ui.form input[type=password] {
  background: transparent !important;
  border: 0 !important;
  border-bottom: 2px solid #6496BB !important;
  border-radius: 0 !important;
  color: white !important;
}

.fade-enter-active {
  transition: opacity 0.4s ease;
}

.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-delay-enter-active {
  transition: opacity 0.4s ease 0.8s;
}

.fade-delay-leave-active {
  transition: opacity 0.15s ease;
}

.fade-delay-enter, .fade-delay-leave-to {
  opacity: 0;
}

</style>
